export const EqualityComparer = (x, y) => x == y;
